export default __webpack_public_path__ + "static/media/sabeer-darr-Upz-tnx2v2s-unsplash.81497c17.jpg";